export default __webpack_public_path__ + "static/media/ic_bell_primary.0a588c99.svg";